import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Aod, Close } from '@mui/icons-material';
import { AppBar, Dialog, Slide } from '@mui/material';
import { useState } from 'react';
import Menu from './Menu';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Mobile = () => {

    const [openMobile, setOpenMobile] = useState(false);

    const handleClickOpen = () => {
        setOpenMobile(true);
    };

    const handleClickClose = () => {
        setOpenMobile(false);
    };

    return (
        <>
            <IconButton color="inherit" onClick={handleClickOpen}>
                <Aod />
            </IconButton>

            <Dialog
                fullScreen
                open={openMobile}
                onClose={handleClickClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative'}} >
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClickClose}
                            aria-label="close"
                        >
                            <Close />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Mobile Menu
                        </Typography>

                    </Toolbar>
                </AppBar>

                <Box >
                    <Menu />
                </Box>

            </Dialog>
        </>
    )
}

export default Mobile